



































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AnalyseThrealtimedata from "../threaltimedata/analyse-threaltimedata.vue";
import AnalyseEnThrealtimedata from "../enthrealtimedata/analyse-enthrealtimedata.vue";
class PageFloorRequest extends PageRequest {
  ftId: Number;
  wId: Number;
  fId: Number;
  etype: Number;
}
@Component({
  components: { AnalyseThrealtimedata,AnalyseEnThrealtimedata},
})
export default class Floors extends AbpBase {
  publicpagerequest: PageFloorRequest = new PageFloorRequest();
  pagerequest: PageFloorRequest = new PageFloorRequest();
  analyseModalShow: boolean = false;
  analyseEnModalShow: boolean = false;
  // datetimenow:Date = new Date();
  mac:String = '';
  selDateTime:Date = new Date();
  locationName: String = '';
  mac1:String = '';
  mac2:String = '';
  mac3:String = '';
  yieldly:String = '';
  years:String = '';
  grade:String = '';
  searchInt: number = 0;
  pagecount:number = 2;
  pageheight:number = 0;
  typelist = [];
  Loading:boolean = false;
  IsPostBack:boolean = false;
  list = [];
  warehouseload:boolean = false;
  floorload:boolean = false;
  distoedge:Number = -500;
  factoryselected:Number = -1;
  warehouseselected:Number = -1;
  floorselected:Number = -1;
  factoryfilter(value: Number,index:Number) {
    this.factoryselected = index;
    this.warehouseselected = -1;
    this.floorselected = -1;
    this.publicpagerequest.ftId = value;
    this.publicpagerequest.wId = 0;
    this.publicpagerequest.fId = 0;
    this.pagerequest.ftId = value;
    this.pagerequest.wId = 0;
    this.pagerequest.fId = 0;
    this.getwarehouse();
    this.warehouseload = true;
    this.floorload = false;
    this.getfloor();
    this.searchInt = 1;
    this.IsPostBack = true;
    this.getpage();
  }
  warehousefilter(value: Number,index:Number) {
    this.warehouseselected = index;
    this.floorselected = -1;
    this.publicpagerequest.wId = value;
    this.publicpagerequest.fId = 0;
    this.pagerequest.wId = value;
    this.pagerequest.fId = 0;
    this.getfloor();
    this.floorload = true;
    this.searchInt = 1;
    this.IsPostBack = true;
    this.getpage();
  }
  floorfilter(value: Number,index:Number) {
    this.floorselected = index;
    this.publicpagerequest.fId = value;
    this.pagerequest.fId = value;
    this.searchInt = 1;
    this.IsPostBack = true;
    this.getpage();
  }
  allfilter(Names:String) {    
    if(Names == 'factory')
    {
       this.factoryselected = -1;
      this.warehouseload = false;
      this.floorload = false;
      this.publicpagerequest.ftId = 0;
      this.publicpagerequest.wId = 0;
      this.publicpagerequest.fId = 0;
      this.pagerequest.ftId = 0;
    this.pagerequest.wId = 0;
    this.pagerequest.fId = 0;
    }
    else if(Names == 'warehouse'){
    this.floorload = false;
    this.publicpagerequest.wId = 0;
    this.publicpagerequest.fId = 0;
    this.pagerequest.wId = 0;
    this.pagerequest.fId = 0;
    this.warehouseselected = -1;
    }
    else if (Names == 'floor'){
      this.floorselected = -1;
      this.publicpagerequest.fId = 0;
      this.pagerequest.fId = 0;
    }
    // this.warehouseload = false;
    // this.floorload = false;
    this.getwarehouse();
    this.getfloor();
    this.searchInt = 1;
    this.IsPostBack = true;
    this.getpage();
  }
  factoryName(value: Number) {
    let clist = this.factorylist();
    for (let entry of clist) {
      if (value == entry.id) {
        return entry.fName;
      }
    }
    return value;
  }
  warehouseName(value: Number) {
    let clist = this.warehouselist();
    for (let entry of clist) {
      if (value == entry.id) {
        return entry.wName;
      }
    }
    return value;
  }
  floorName(value: Number) {
    let clist = this.floorlist();
    for (let entry of clist) {
      if (value == entry.id) {
        return entry.fName;
      }
    }
    return value;
  }
  setsmoke(sid){
    let smokelist = this.smokecriblist();
    for(let entry of smokelist){
      if(sid == entry.id){
        this.yieldly = entry.yieldly;
        this.years = entry.year;
        this.grade = entry.grade;
        break;
      }
    }
  }
  analyse(mac:String,ftId:Number,wId:Number,fId:Number,locationName:String,scId:Number,endTime:Date,mac1:String,mac2:String,mac3:String){
    this.setsmoke(scId);
    this.analyseModalShow = true;
    this.mac = mac;
    if(locationName == null){
       this.locationName =this.factoryName(ftId) + this.warehouseName(wId) + this.floorName(fId);
    }
    else{
      this.locationName = this.warehouseName(wId) + this.floorName(fId) + locationName;
    }
     let datetime1 = new Date(endTime);
    //  if(endTime.toString() == '0001-01-01T00:00:00'){
    //  datetime1 = new Date();
    //  }
     this.selDateTime = datetime1;
     this.mac1 = mac1;
     this.mac2 = mac2;
     this.mac3 = mac3;
  }
   Enanalyse(mac:String,ftId:Number,wId:Number,fId:Number,locationName:String,endTime:Date){
    this.analyseEnModalShow = true;
    this.mac = mac;
    if(locationName == null){
       this.locationName =this.factoryName(ftId) + this.warehouseName(wId) + this.floorName(fId);
    }
    else{
      this.locationName = this.warehouseName(wId) + this.floorName(fId) + locationName;
    }
     let datetime1 = new Date(endTime);
     if(endTime.toString() == '0001-01-01T00:00:00'){
     datetime1 = new Date();
     }
     this.selDateTime = datetime1;
  }
  getlist() {
    this.typelist = [];
    var list = this.list;
    var ftId = 0;
    var wId = 0;
    var fId = 0;
    for (var i = 0; i < list.length; i++) {
      if (i == 0) {
        ftId = list[i].ftId;
        wId = list[i].wId;
        fId = list[i].fId;
        this.typelist.splice(i,1,{ "ftId": ftId, "wId": wId, "fId": fId });
      } else {
        if (ftId != list[i].ftId || wId != list[i].wId || fId != list[i].fId) {
          ftId = list[i].ftId;
          wId = list[i].wId;
          fId = list[i].fId;
          this.typelist.splice(this.typelist.length,1,{ "ftId": ftId, "wId": wId, "fId": fId });
        }
      }
    }
  }
  computTime(endTime:string){
    var datetimenow = new Date().getTime();
    var endtimenow = new Date(endTime).getTime();
    var hours = (datetimenow - endtimenow) / 60000 / 60;
    return hours;

  }
  get factory() {
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  get floor() {
    return this.$store.state.floor.list;
  }
    get ththreshold(){
    return this.$store.state.ththreshold.list;
  }
  get ththresholdlist(){
    return this.$store.state.ththreshold.list;
  }
  warehouselist() {
    return this.$store.state.warehouse.list;
  }
  factorylist() {
    return this.$store.state.factory.list;
  }
  floorlist() {
    return this.$store.state.floor.list;
  }
    smokecriblist(){
    return this.$store.state.smokecrib.list;
  }
  get totalCount() {
    return this.$store.state.thequipment.totalCount;
  }
  get lists() {
    return this.$store.state.thequipment.list;
  }
  get currentPage() {
    return this.$store.state.thequipment.currentPage;
  }
  get pageSize() {
    return this.$store.state.thequipment.pageSize;
  }
  pageChange(page: number) {
    this.$store.commit("thequipment/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("thequipment/setPageSize", pagesize);
    this.getpage();
  }
  async getfactory() {
    //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      data: this.publicpagerequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      data: this.publicpagerequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getAll",
      data: this.publicpagerequest,
    });
  }
    async getththreshold(){
      //阈值方案
    //filters
    await this.$store.dispatch({
      type: "ththreshold/getPage",
      data: this.publicpagerequest,
    });
  }
  async getsmokecrib() {
    //烟叶
    //filters
    await this.$store.dispatch({
      type: "smokecrib/getAll",
       data: this.publicpagerequest,
    });
  }
  userName() {
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
  async getpage() {
    this.pagerequest.etype = 2;
    if (this.searchInt == 1) {
      this.pagerequest.maxResultCount = 25;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
      this.pagecount = 2;
    } else {
      this.pagerequest.maxResultCount = 25;
      this.pagerequest.skipCount = (this.currentPage - 1) * 25;
    }
    await this.$store.dispatch({
      type: "thequipment/GetGlobalPaged",
      data: this.pagerequest,
    });
    if (this.IsPostBack) {
      this.list = this.lists;
      this.IsPostBack = false;
    }
    if(this.Loading){
      var temp = this.lists;
      this.list = this.list.concat(this.lists);
      this.pagecount ++;
      this.Loading = false;
    }
    this.getlist();
  }
  handleSc(e){
　　    //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = e.target.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight = e.target.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = e.target.scrollHeight;
        //滚动条到底部的条件
        if(scrollTop + windowHeight > (scrollHeight*0.85)&&Math.ceil(this.totalCount/this.pageSize)>=this.pagecount&&!this.Loading){
          this.Loading = true;
          this.pageChange(this.pagecount);
        }
  }
  created() {
    this.$store.state.thequipment.pageSize=10;
    this.$store.state.thequipment.currentPage=1;
    this.$store.state.thequipment.totalCount=0;
    this.getfactory();
    this.getwarehouse();
    this.getfloor();
    this.IsPostBack = true;
    this.getpage();
    this.getsmokecrib();
    this.getththreshold();
  }
  mounted () {
    this.pageheight = document.body.clientHeight - 260;
    window.addEventListener('scroll',this.handleSc,true);
  }
  destroyed () {
    window.removeEventListener('scroll',this.handleSc,true);
  }
}
